module.exports = __webpack_public_path__ + "static/media/INI.d9951489.svg";